import { EventName } from '@lit/react';
import { BlocksTableObject } from 'blocks-nextjs/blocks-web-components/components/table-object/table-object';
import {
  BlocksRowCellSelectAllEvent,
  BlocksRowDragEnd,
  BlocksRowExpandEvent,
  BlocksScrollXEndEvent,
  BlocksTableResizeEvent,
  BlocksTableScrollXEvent,
  BlocksTableScrollYEndEvent,
  BlocksTableScrollYEvent
} from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTableObject = createComponent({
  react: React,
  tagName: 'cat-table-object',
  elementClass: BlocksTableObject,
  events: {
    onBlTableScrollY: 'bl-table-scroll-y' as EventName<BlocksTableScrollYEvent>,
    onBlTableScrollYEnd: 'bl-table-scroll-y-end' as EventName<BlocksTableScrollYEndEvent>,
    onBlTableScrollX: 'bl-table-scroll-x' as EventName<BlocksTableScrollXEvent>,
    onBlTableScrollXEnd: 'bl-table-scroll-x-end' as EventName<BlocksScrollXEndEvent>,
    onBlRowExpand: 'bl-row-expand' as EventName<BlocksRowExpandEvent>,
    onBlTableResize: 'bl-table-resize' as EventName<BlocksTableResizeEvent>,
    onBlRowDragEnd: 'bl-row-drag-end' as EventName<BlocksRowDragEnd>,
    onBlRowCellSelectAll: 'bl-row-cell-select-all' as EventName<BlocksRowCellSelectAllEvent>
  }
});
